<!-- Large/card discount display-->
<div class="stairstep-price-display-container" *ngIf="size.toLowerCase() === 'large'">
  <div class="stairstep-large-records" *ngFor="let stairstep of stairsteps">
    <div class="stairstep-top-info">
      <span>{{ generateTopInfo(stairstep) }}</span>
    </div>
    <glxy-frequency
      *ngIf="stairstep.price && stairstep.price > 0"
      [value]="stairstep.price | priceInDollars : currencyCode : 'en-US'"
      [currencyCode]="currencyCode | resolveCurrencyCode : 'en-US'"
      [form]="'verbose'"
      [align]="align"
      [frequency]="frequency"
      [size]="size"
      [ngClass]="{
        'large-inner-frequency': size === 'large',
        'one-time-frequency': frequency === Frequency.ONE_TIME,
        'align-center': align.toLowerCase() === 'center'
      }"
    ></glxy-frequency>
    <span *ngIf="!stairstep.price || stairstep.price === 0">{{ freeLabel }}</span>
  </div>
  <span class="dialog-link" *ngIf="shouldShowDialogLink" (click)="openStepsDialog()">View all pricing</span>
</div>
<!-- Small/table/list discount display-->
<div *ngIf="size.toLowerCase() === 'regular'">
  <div *ngFor="let stairstep of stairsteps">
    <div style="text-align: left">
      {{ generateTopInfo(stairstep) }}
      <span style="float: right">
        <glxy-frequency
          *ngIf="stairstep.price && stairstep.price > 0"
          [value]="stairstep.price | priceInDollars : currencyCode : 'en-US'"
          [currencyCode]="currencyCode | resolveCurrencyCode : 'en-US'"
          [form]="'short'"
          [align]="align"
          [frequency]="frequency"
          [size]="size"
          [ngClass]="{
            'large-inner-frequency': size === 'large',
            'one-time-frequency': frequency === Frequency.ONE_TIME,
            'align-center': align.toLowerCase() === 'center'
          }"
        ></glxy-frequency>
        <span *ngIf="!stairstep.price || stairstep.price === 0">{{ freeLabel }}</span>
      </span>
    </div>
  </div>
</div>
